import { useEffect } from 'react';
import { useGetCurrentUserQuery } from '@/store/api/userApi';

interface UseCurrencyReturn {
  currencySymbol: string;
  currencyCode?: string;
  isLoading: boolean;
  error: any;
}

/**
 * Custom hook to get company currency information
 * Falls back to '$' if currency is unavailable or loading fails
 * @returns {UseCurrencyReturn} Currency symbol, code, loading state, and error
 */
export const useCurrency = (): UseCurrencyReturn => {
  const { data: currentUserData, error: currentUserError, isLoading } = useGetCurrentUserQuery();

  useEffect(() => {
    if (currentUserError) {
      console.error('Unable to load company currency. Using default "$".');
    }
  }, [currentUserError]);

  const currencySymbol = currentUserData?.company_details?.profile?.currency?.symbol || '$';
  const currencyCode = currentUserData?.company_details?.profile?.currency?.code;

  return {
    currencySymbol,
    currencyCode,
    isLoading,
    error: currentUserError,
  };
};